module.exports = __webpack_public_path__ + "static/media/1021945.56604e05.jpg";